import React from 'react';
import GenericPullAndPushToolView from '../GenericPullAndPushToolView';
import VdooConfigListing from './VdooConfigListing';
import VdooCredentialsForm from './VdooCredentialsForm';

const VdooPullAndPushView = (props) => (
    <GenericPullAndPushToolView 
        {...props}
        PullCredentialForm={VdooCredentialsForm}
        PullConfigListingView={VdooConfigListing}
     />
);

export default VdooPullAndPushView;
